<template>
  <div class="grid-container my-5">
    <section-header size="xl">
      <heading level="1" size="xl" v-html="bp('login.login')"></heading>
    </section-header>
    <div v-if="viewBreakpointIs('small')">
      <collapse
        icon-active="expand_more"
        icon-inactive="expand_less"
        icon-position="right"
        :default-active="false"
        :accordion="true"
        :value="['guest']"
        class="mb-2"
      >
        <collapse-item name="guest">
          <div slot="title" class="heading heading--sm">{{ bp('guest.checkout') }}</div>
          <guest-checkout :base-properties="baseProperties" :options="options" />
        </collapse-item>
        <collapse-item name="login">
          <div slot="title" class="heading heading--sm">{{ bp('login.title') }}</div>
          <user-login :base-properties="baseProperties" :options="options" />
        </collapse-item>
      </collapse>
      <div class="text-sm">
        <a :href="withContextPath('/login/')" class="hover:underline" v-html="bp('registration.link')"></a>
      </div>
    </div>
    <div v-else class="flex my-5">
      <div class="w-1/2 border-r border-gray-10">
        <div class="max-w-sm md:mr-2 lg:mx-6">
          <div class="text-lg font-semibold mb-2" v-html="bp('guest.checkout')"></div>
          <guest-checkout :base-properties="baseProperties" :options="options" />
        </div>
      </div>
      <div class="w-1/2">
        <div class="max-w-sm md:ml-2 lg:mx-6">
          <div class="text-lg font-semibold mb-2" v-html="bp('login.title')"></div>
          <user-login :base-properties="baseProperties" :options="options" class="mb-2" />
          <div class="text-sm">
            <a :href="withContextPath('/login/')" class="hover:underline" v-html="bp('registration.link')"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserLogin from '@/components/containers/my-account/UserLogin';
import GuestCheckout from '@/components/containers/checkout/GuestCheckout';
import viewSize from '@/mixins/view-size';
import {Url} from '@/utils/url';

export default {
  name: 'LoginCheckoutContainer',
  components: {UserLogin, GuestCheckout},
  mixins: [viewSize],
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    withContextPath: (url) => Url.withContextPath(url),
  },
};
</script>
